import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App';
import './index.scss';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(TonConnectUIProvider, { manifestUrl: "https://raw.githubusercontent.com/delab-team/de-donate/main/connect.txt", children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
